<template>
  <div class="width-100 min-height container">
    <img src="../../assets/image/msjd/2_01.jpg" width="100%" alt="" />
    <div class="check-box padding-90 width-100">
      <div
        class="width-100 margin-bs flex-row justify-content-spaceBetween align-items-star"
        v-for="(item, index) in list"
        :key="index"
        @click="item.ifSelect = !item.ifSelect"
      >
        <div class="width-10">
          <van-image
            :src="item.ifSelect ? require('../../assets/image/msjd/4.png') : require('../../assets/image/msjd/5.png')"
            :style="item.ifSelect ? 'width:21px' : 'width:18px;top:5px'"
            class="margin-ls position-relative"
          ></van-image>
        </div>
        <div class="width-90 white fs-mid">{{ item.text }}</div>
      </div>
    </div>
    <div class="fixed-bottom">
      <van-checkbox class="margin-b" v-model="checked" shape="square" icon-size="16" checked-color="red"
        ><p class="white fs-sml">我已查看并同意监督须知</p></van-checkbox
      >
      <div class="width-100 margin-b flex-row justify-content-center align-items-center">
        <img src="../../assets/image/msjd/1.png" width="40%" class="margin-r margin-bs" @click="goForm(1)" alt="" />
        <img src="../../assets/image/msjd/2.png" width="40%" class="margin-l margin-bs" @click="goForm(2)" alt="" />
      </div>
      <p class="fs-sml white textAlign-c opacity-5">中共瑞安市纪律检查委员会</p>
    </div>

    <van-popup v-model="show" class="width-80 popup padding-90" round :close-on-click-overlay="false">
      <p class="title">监督问题须知</p>
      <p class="text">
        根据市委统一部署，市委巡察组将巡察陶山镇、飞云街道、塘下镇、马屿镇、桐浦镇所辖86个村(社区)党组织。巡察期间一大党员、干部、群众对巡察对象如有意见建议，请依规依纪依法、实事求是反映提倡实名，我们会严格保密。
      </p>
      <p class="title">受理范围</p>
      <p class="text">根据巡察工作有关规定，对反映其他问题的信访举报，巡察期间只接收、不处理，按规定转有关部门。</p>
      <van-button
        class="button"
        @click="
          show = false;
          checked = true;
        "
        color="#ae231b"
        round
        >我已知晓</van-button
      >
    </van-popup>
  </div>
</template>
<script>
import { Toast } from 'vant';

export default {
  name: 'msjdIndex',
  data() {
    return {
      checked: false,
      list: [
        {
          id: '1',
          ifSelect: false,
          text: '对企业进行选择性执法、随意性执法、粗暴执法等干扰企业正常生产经营活动，徇私枉法办”关系案“人情案”的'
        },
        {
          id: '2',
          ifSelect: false,
          text: '未落实”最多跑一次”改革要求，在涉企服务中随意拖延、被动应付、敷衍塞责、不负责任,让企业多头跑重复跑的'
        },
        {
          id: '3',
          ifSelect: false,
          text: '在落实涉企优惠政策过程中”上有政策、下有对策藏着不给、拖着不办，刁难企业、推诿扯皮或以各种理由致使涉企优惠政策不落地的'
        },
        {
          id: '4',
          ifSelect: false,
          text: '利用职权在企业搭股经商、强制或暗示企业购买指定产品或服务、向企业乱收费、”吃拿卡要以及其他干抗企业日常运行和预害企业利益的'
        },
        {
          id: '5',
          ifSelect: false,
          text: '干预和插手工程招投标，限制或者变相限制符合准入条件的企业参与招投标采购活动，以及利用知悉或者掌握的内幕信息谋取私利等'
        },
        {
          id: '6',
          ifSelect: false,
          text: '在招商引资项目签约后，无故不启动、不推进，不落实，或者对投资者反映的问题不及时协调解决的'
        },
        {
          id: '7',
          ifSelect: false,
          text: '在服务群众过程中漠视、侵害群众利益的'
        }
      ],
      show: false
    };
  },
  created() {},
  methods: {
    goForm(t) {
      let types = '';
      this.list.forEach((item) => {
        if (item.ifSelect) {
          types += ',' + item.id;
        }
      });
      if (types === '') {
        Toast.fail('请先勾选投诉类型');
      } else {
        types = types.substring(1);
        if (!this.checked) {
          this.show = true;
        } else {
          this.$router.push({ path: '/msjdForm', query: { type: types, t: t } });
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../assets/css/common.css';
@import '../../assets/css/demo1.css';
@import '../../assets/css/demo2.css';
.container {
  background: #ae231b;
  .check-box {
    background: url('../../assets/image/msjd/2_02.jpg') round;
    padding-bottom: 220px;
  }
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 80px 8% 20px;
    background: url('../../assets/image/msjd/2_03.png') round;
    /deep/.van-checkbox__icon .van-icon {
      border-color: white;
      background-color: white;
    }
  }
  .popup {
    .title {
      font-size: 18px;
      padding: 10px 0;
      border-bottom: 1px solid black;
      margin-bottom: 10px;
    }
    .text {
      color: #333333;
      margin-bottom: 20px;
    }
    .button {
      margin: 40px 30% 10px;
      width: 40%;
    }
  }
}
img {
  vertical-align: middle;
}
</style>
